import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@shadcn-in-nx/ui/tabs";
import { UserPlus, Building2, Globe, Code } from "lucide-react";
import PublishUsersTab from "./PublishUsersTab";
import PublishIntranetTab from "./PublishIntranetTab";
import PublishDomainTab from "./PublishDomainTab";
import PublishEmbedTab from "./PublishEmbedTab";
import { useTranslation } from "react-i18next";

function PublishTabs({ data, workflow, onGoToDomains, onGoToUsers, onClose }) {
    const { t } = useTranslation();

    return (
        <Tabs defaultValue="users" className="w-full">
            <div className="px-4 pt-3 pb-0">
                <TabsList className="w-full bg-transparent rounded-none gap-2">
                    <TabsTrigger value="users" className="flex items-center gap-1.5 text-xs px-1 pb-2">
                        <UserPlus className="w-3.5 h-3.5" />
                        {t("publishModal.tabs.users")}
                    </TabsTrigger>
                    <TabsTrigger value="portal" className="flex items-center gap-1.5 text-xs px-1 pb-2">
                        <Building2 className="w-3.5 h-3.5" />
                        {t("publishModal.tabs.portal")}
                    </TabsTrigger>
                    <TabsTrigger value="domain" className="flex items-center gap-1.5 text-xs px-1 pb-2">
                        <Globe className="w-3.5 h-3.5" />
                        {t("publishModal.tabs.domain")}
                    </TabsTrigger>
                    <TabsTrigger value="embed" className="flex items-center gap-1.5 text-xs px-1 pb-2">
                        <Code className="w-3.5 h-3.5" />
                        {t("publishModal.tabs.embed")}
                    </TabsTrigger>
                </TabsList>
            </div>
            <div className="px-4 py-4 min-h-[180px]">
                <TabsContent value="users" className="mt-0 focus-visible:ring-0">
                    <PublishUsersTab onGoToUsers={onGoToUsers} />
                </TabsContent>
                <TabsContent value="portal" className="mt-0 focus-visible:ring-0">
                    <PublishIntranetTab
                        hasTeamMembers={data.hasTeamMembers}
                        publicationInfo={data.publicationInfo}
                        isLoadingPublicationInfo={data.isLoadingPublicationInfo}
                        companyGroups={data.companyGroups}
                        selectedTargets={data.selectedPublishingTargets}
                        setSelectedTargets={data.setSelectedPublishingTargets}
                        isPublishing={data.isPublishing}
                        onPublish={data.handleGroupPublish}
                        onUnpublish={data.handleUnpublishGroup}
                        onClose={onClose}
                    />
                </TabsContent>
                <TabsContent value="domain" className="mt-0 focus-visible:ring-0">
                    <PublishDomainTab
                        workflow={workflow}
                        publicUrl={data.publicUrl}
                        isGeneratingUrl={data.isGeneratingUrl}
                        hasActiveSubscription={data.hasActiveSubscription}
                        onGenerateUrl={data.generatePublicUrl}
                        onRemoveUrl={data.handleRemovePublicUrl}
                        onGoToDomains={onGoToDomains}
                    />
                </TabsContent>
                <TabsContent value="embed" className="mt-0 focus-visible:ring-0">
                    <PublishEmbedTab getEmbedUrl={data.getEmbedUrl} getEmbedCode={data.getEmbedCode} />
                </TabsContent>
            </div>
        </Tabs>
    );
}

export default React.memo(PublishTabs);
